<template>
  <div class="ca-page">
    <v-row class="ca-page-title">
      <v-col>
        <h1 class="ca-title">Design Style</h1>
        <h2 class="ca-subtitle">
          Which of these examples best represents your style?
        </h2>
      </v-col>
    </v-row>
    <v-row class="ca-content">
      <v-col cols="12" class="ca-banners ca-options">
        <v-row v-for="(chunk, i) in chunkBanners" :key="i">
          <v-col v-for="(col, i) in chunk" md="6" sm="12" :key="i">
            <banner :option="col.option" :pictures="col.pictures" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
import Banner from "../components/Banner.vue";

export default {
  data() {
    return {
      banners: [
        {
          option: "established",
          pictures: [
            {
              brand: "Acura",
              src: require("../assets/images/banners/Acura/CM-SS-CA-Acura-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/206/original/CM-SS-CA-Acura-Established.jpeg?1671483541"
            },
            {
              brand: "BMW",
              src: require("../assets/images/banners/BMW/CM-SL-CA-BMW-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/209/original/CM-SL-CA-BMW-Established.jpeg?1671483554"
            },
            {
              brand: "Buick",
              src: require("../assets/images/banners/Buick/CM-SS-CA-Buick-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/213/original/CM-SS-CA-Buick-Established.jpeg?1671483620"
            },
            {
              brand: "Cadillac",
              src: require("../assets/images/banners/Cadillac/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/218/original/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Established.jpeg?1671483631"
            },
            {
              brand: "Chevrolet",
              src: require("../assets/images/banners/Chevrolet/CM-SS-CA-Chevy-Established.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/223/original/CM-SS-CA-Chevy-Established.jpg?1671483642"
            },
            {
              brand: "CJDR",
              src: require("../assets/images/banners/CJDR/CM-KT-CA-CJDR-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/225/original/CM-KT-CA-CJDR-Established.jpeg?1671483652"
            },
            {
              brand: "Ford",
              src: require("../assets/images/banners/Ford/CM-CA-112122-Ford-Established.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/232/original/CM-CA-112122-Ford-Established.jpg?1671483661"
            },
            {
              brand: "GMC",
              src: require("../assets/images/banners/GMC/SOKAL-WEB-112822-CreativeAnalysis-GMC-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/234/original/SOKAL-WEB-112822-CreativeAnalysis-GMC-Established.jpeg?1671483670"
            },
            {
              brand: "Honda",
              src: require("../assets/images/banners/Honda/CM-SL-CA-Honda-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/237/original/CM-SL-CA-Honda-Established.jpeg?1671483679"
            },
            {
              brand: "Hyundai",
              src: require("../assets/images/banners/Hyundai/CM-SS-CA-Hyundai-Established.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/242/original/CM-SS-CA-Hyundai-Established.jpg?1671483689"
            },
            {
              brand: "INFINITI",
              src: require("../assets/images/banners/Infiniti/CM-SL-CA-Infiniti-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/245/original/CM-SL-CA-Infiniti-Established.jpeg?1671483698"
            },
            {
              brand: "Kia",
              src: require("../assets/images/banners/Kia/CM-SL-CA-Kia-Established-1.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/249/original/CM-SL-CA-Kia-Established.jpeg?1671483706"
            },
            {
              brand: "Lincoln",
              src: require("../assets/images/banners/Lincoln/CM-SL-CA-Lincoln-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/253/original/CM-SL-CA-Lincoln-Established.jpeg?1671483716"
            },
            {
              brand: "Mazda",
              src: require("../assets/images/banners/Mazda/CM-MR-CA-Mazda-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/257/original/CM-MR-CA-Mazda-Established.jpeg?1671483724"
            },
            {
              brand: "Mitsubishi",
              src: require("../assets/images/banners/Mitsubishi/CM-NL-CA-Mitsubishi-Established.png"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/261/original/CM-NL-CA-Mitsubishi-Established.png?1671483734"
            },
            {
              brand: "Nissan",
              src: require("../assets/images/banners/Nissan/CM-SL-CA-Nissan-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/265/original/CM-SL-CA-Nissan-Established.jpeg?1671483743"
            },
            {
              brand: "Subaru",
              src: require("../assets/images/banners/Subaru/CM-SL-CA-Subaru-Established.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/269/original/CM-SL-CA-Subaru-Established.jpg?1671483751"
            },
            {
              brand: "Toyota",
              src: require("../assets/images/banners/Toyota/CM-MS-CA-23-Toyota-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/273/original/CM-MS-CA-23-Toyota-Established.jpeg?1671483760"
            },
            {
              brand: "Volkswagen",
              src: require("../assets/images/banners/Volkswagen/CM-SL-CA-Volkswagen-Established.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/277/original/CM-SL-CA-Volkswagen-Established.jpg?1671483775"
            },
            {
              brand: "Volvo",
              src: require("../assets/images/banners/Volvo/CM-SL-CA-Volvo-Established.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/281/original/CM-SL-CA-Volvo-Established.jpeg?1671483783"
            },
          ],
        },
        {
          option: "lifestyle",
          pictures: [
            {
              brand: "Acura",
              src: require("../assets/images/banners/Acura/CM-SS-CA-Acura-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/205/original/CM-SS-CA-Acura-Lifestyle.jpeg?1671483541"
            },
            {
              brand: "BMW",
              src: require("../assets/images/banners/BMW/CM-SL-CA-BMW-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/211/original/CM-SL-CA-BMW-Lifestyle.jpeg?1671483554"
            },
            {
              brand: "Buick",
              src: require("../assets/images/banners/Buick/CM-SS-CA-Buick-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/214/original/CM-SS-CA-Buick-Lifestyle.jpeg?1671483620"
            },
            {
              brand: "Cadillac",
              src: require("../assets/images/banners/Cadillac/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/217/original/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Lifestyle.jpeg?1671483631"
            },
            {
              brand: "Chevrolet",
              src: require("../assets/images/banners/Chevrolet/CM-SS-CA-Chevy-Lifestyle.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/221/original/CM-SS-CA-Chevy-Lifestyle.jpg?1671483642"
            },
            {
              brand: "CJDR",
              src: require("../assets/images/banners/CJDR/CM-KT-CA-CJDR-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/227/original/CM-KT-CA-CJDR-Lifestyle.jpeg?1671483652"
            },
            {
              brand: "Ford",
              src: require("../assets/images/banners/Ford/CM-CA-111722-Ford-LifeStyle.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/230/original/CM-CA-111722-Ford-LifeStyle.jpg?1671483661"
            },
            {
              brand: "GMC",
              src: require("../assets/images/banners/GMC/SOKAL-WEB-112822-CreativeAnalysis-GMC-LIfestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/233/original/SOKAL-WEB-112822-CreativeAnalysis-GMC-LIfestyle.jpeg?1671483670"
            },
            {
              brand: "Honda",
              src: require("../assets/images/banners/Honda/CM-SL-CA-Honda-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/238/original/CM-SL-CA-Honda-Lifestyle.jpeg?1671483679"
            },
            {
              brand: "Hyundai",
              src: require("../assets/images/banners/Hyundai/CM-SS-CA-Hyundai-Lifestyle.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/241/original/CM-SS-CA-Hyundai-Lifestyle.jpg?1671483689"
            },
            {
              brand: "INFINITI",
              src: require("../assets/images/banners/Infiniti/CM-SL-CA-Infiniti-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/246/original/CM-SL-CA-Infiniti-Lifestyle.jpeg?1671483698"
            },
            {
              brand: "Kia",
              src: require("../assets/images/banners/Kia/CM-SL-CA-Kia-Lifestyle-1.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/250/original/CM-SL-CA-Kia-Lifestyle.jpeg?1671483706"
            },
            {
              brand: "Lincoln",
              src: require("../assets/images/banners/Lincoln/CM-SL-CA-Lincoln-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/254/original/CM-SL-CA-Lincoln-Lifestyle.jpeg?1671483716"
            },
            {
              brand: "Mazda",
              src: require("../assets/images/banners/Mazda/CM-MR-CA-Mazda-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/258/original/CM-MR-CA-Mazda-Lifestyle.jpeg?1671483724"
            },
            {
              brand: "Mitsubishi",
              src: require("../assets/images/banners/Mitsubishi/CM-NL-CA-Mitsubishi-Lifestyle.png"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/262/original/CM-NL-CA-Mitsubishi-Lifestyle.png?1671483734"
            },
            {
              brand: "Nissan",
              src: require("../assets/images/banners/Nissan/CM-SL-CA-Nissan-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/266/original/CM-SL-CA-Nissan-Lifestyle.jpeg?1671483743"
            },
            {
              brand: "Subaru",
              src: require("../assets/images/banners/Subaru/CM-SL-CA-Subaru-Lifestyle.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/270/original/CM-SL-CA-Subaru-Lifestyle.jpg?1671483752"
            },
            {
              brand: "Toyota",
              src: require("../assets/images/banners/Toyota/CM-MS-CA-23-Toyota-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/274/original/CM-MS-CA-23-Toyota-Lifestyle.jpeg?1671483766"
            },
            {
              brand: "Volkswagen",
              src: require("../assets/images/banners/Volkswagen/CM-SL-CA-Volkswagen-Lifestyle.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/278/original/CM-SL-CA-Volkswagen-Lifestyle.jpg?1671483775"
            },
            {
              brand: "Volvo",
              src: require("../assets/images/banners/Volvo/CM-SL-CA-Volvo-Lifestyle.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/282/original/CM-SL-CA-Volvo-Lifestyle.jpeg?1671483784"
            },
          ],
        },
        {
          option: "modern",
          pictures: [
            {
              brand: "Acura",
              src: require("../assets/images/banners/Acura/CM-SS-CA-Acura-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/208/original/CM-SS-CA-Acura-Modern.jpeg?1671483542"
            },
            {
              brand: "BMW",
              src: require("../assets/images/banners/BMW/CM-SL-CA-BMW-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/210/original/CM-SL-CA-BMW-Modern.jpeg?1671483554"
            },
            {
              brand: "Buick",
              src: require("../assets/images/banners/Buick/CM-SS-CA-Buick-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/215/original/CM-SS-CA-Buick-Modern.jpeg?1671483621"
            },
            {
              brand: "Cadillac",
              src: require("../assets/images/banners/Cadillac/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/219/original/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Modern.jpeg?1671483631"
            },
            {
              brand: "Chevrolet",
              src: require("../assets/images/banners/Chevrolet/CM-SS-CA-Chevy-Modern.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/222/original/CM-SS-CA-Chevy-Modern.jpg?1671483642"
            },
            {
              brand: "CJDR",
              src: require("../assets/images/banners/CJDR/CM-KT-CA-CJDR-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/226/original/CM-KT-CA-CJDR-Modern.jpeg?1671483652"
            },
            {
              brand: "Ford",
              src: require("../assets/images/banners/Ford/CM-CA-111722-Ford-Modern.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/229/original/CM-CA-111722-Ford-Modern.jpg?1671483661"
            },
            {
              brand: "GMC",
              src: require("../assets/images/banners/GMC/SOKAL-WEB-112822-CreativeAnalysis-GMC-Modern-Round.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/235/original/SOKAL-WEB-112822-CreativeAnalysis-GMC-Modern-Round.jpeg?1671483670"
            },
            {
              brand: "Honda",
              src: require("../assets/images/banners/Honda/CM-SL-CA-Honda-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/239/original/CM-SL-CA-Honda-Modern.jpeg?1671483679"
            },
            {
              brand: "Hyundai",
              src: require("../assets/images/banners/Hyundai/CM-SS-CA-Hyundai-Modern.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/243/original/CM-SS-CA-Hyundai-Modern.jpg?1671483690"
            },
            {
              brand: "INFINITI",
              src: require("../assets/images/banners/Infiniti/CM-SL-CA-Infiniti-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/247/original/CM-SL-CA-Infiniti-Modern.jpeg?1671483698"
            },
            {
              brand: "Kia",
              src: require("../assets/images/banners/Kia/CM-SL-CA-Kia-Modern-1.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/252/original/CM-SL-CA-Kia-Modern.jpeg?1671483707"
            },
            {
              brand: "Lincoln",
              src: require("../assets/images/banners/Lincoln/CM-SL-CA-Lincoln-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/255/original/CM-SL-CA-Lincoln-Modern.jpeg?1671483716"
            },
            {
              brand: "Mazda",
              src: require("../assets/images/banners/Mazda/CM-MR-CA-Mazda-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/259/original/CM-MR-CA-Mazda-Modern.jpeg?1671483725"
            },
            {
              brand: "Mitsubishi",
              src: require("../assets/images/banners/Mitsubishi/CM-NL-CA-Mitsubishi-Modern.png"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/263/original/CM-NL-CA-Mitsubishi-Modern.png?1671483735"
            },
            {
              brand: "Nissan",
              src: require("../assets/images/banners/Nissan/CM-SL-CA-Nissan-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/267/original/CM-SL-CA-Nissan-Modern.jpeg?1671483743"
            },
            {
              brand: "Subaru",
              src: require("../assets/images/banners/Subaru/CM-SL-CA-Subaru-Modern.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/271/original/CM-SL-CA-Subaru-Modern.jpg?1671483752"
            },
            {
              brand: "Toyota",
              src: require("../assets/images/banners/Toyota/CM-MS-CA-23-Toyota-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/275/original/CM-MS-CA-23-Toyota-Modern.jpeg?1671483766"
            },
            {
              brand: "Volkswagen",
              src: require("../assets/images/banners/Volkswagen/CM-SL-CA-Volkswagen-Modern.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/279/original/CM-SL-CA-Volkswagen-Modern.jpg?1671483775"
            },
            {
              brand: "Volvo",
              src: require("../assets/images/banners/Volvo/CM-SL-CA-Volvo-Modern.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/283/original/CM-SL-CA-Volvo-Modern.jpeg?1671483784"
            },
          ],
        },
        {
          option: "playful",
          pictures: [
            {
              brand: "Acura",
              src: require("../assets/images/banners/Acura/CM-SS-CA-Acura-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/207/original/CM-SS-CA-Acura-Playful.jpeg?1671483542"
            },
            {
              brand: "BMW",
              src: require("../assets/images/banners/BMW/CM-SL-CA-BMW-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/212/original/CM-SL-CA-BMW-Playful.jpeg?1671483615"
            },
            {
              brand: "Buick",
              src: require("../assets/images/banners/Buick/CM-SS-CA-Buick-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/216/original/CM-SS-CA-Buick-Playful.jpeg?1671483621"
            },
            {
              brand: "Cadillac",
              src: require("../assets/images/banners/Cadillac/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/220/original/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Playful.jpeg?1671483631"
            },
            {
              brand: "Chevrolet",
              src: require("../assets/images/banners/Chevrolet/CM-SS-CA-Chevy-Playful.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/224/original/CM-SS-CA-Chevy-Playful.jpg?1671483643"
            },
            {
              brand: "CJDR",
              src: require("../assets/images/banners/CJDR/CM-KT-CA-CJDR-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/228/original/CM-KT-CA-CJDR-Playful.jpeg?1671483653"
            },
            {
              brand: "Ford",
              src: require("../assets/images/banners/Ford/CM-CA-112122-Ford-Playful.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/231/original/CM-CA-112122-Ford-Playful.jpg?1671483661"
            },
            {
              brand: "GMC",
              src: require("../assets/images/banners/GMC/SOKAL-WEB-112822-CreativeAnalysis-GMC-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/236/original/SOKAL-WEB-112822-CreativeAnalysis-GMC-Playful.jpeg?1671483671"
            },
            {
              brand: "Honda",
              src: require("../assets/images/banners/Honda/CM-SL-CA-Honda-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/240/original/CM-SL-CA-Honda-Playful.jpeg?1671483679"
            },
            {
              brand: "Hyundai",
              src: require("../assets/images/banners/Hyundai/CM-SS-CA-Hyundai-Playful.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/244/original/CM-SS-CA-Hyundai-Playful.jpg?1671483690"
            },
            {
              brand: "INFINITI",
              src: require("../assets/images/banners/Infiniti/CM-SL-CA-Infiniti-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/248/original/CM-SL-CA-Infiniti-Playful.jpeg?1671483698"
            },
            {
              brand: "Kia",
              src: require("../assets/images/banners/Kia/CM-SL-CA-Kia-Playful-1.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/251/original/CM-SL-CA-Kia-Playful.jpeg?1671483707"
            },
            {
              brand: "Lincoln",
              src: require("../assets/images/banners/Lincoln/CM-SL-CA-Lincoln-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/256/original/CM-SL-CA-Lincoln-Playful.jpeg?1671483716"
            },
            {
              brand: "Mazda",
              src: require("../assets/images/banners/Mazda/CM-MR-CA-Mazda-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/260/original/CM-MR-CA-Mazda-Playful.jpeg?1671483725"
            },
            {
              brand: "Mitsubishi",
              src: require("../assets/images/banners/Mitsubishi/CM-NL-CA-Mitsubishi-Playful.png"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/264/original/CM-NL-CA-Mitsubishi-Playful.png?1671483735"
            },
            {
              brand: "Nissan",
              src: require("../assets/images/banners/Nissan/CM-SL-CA-Nissan-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/268/original/CM-SL-CA-Nissan-Playful.jpeg?1671483743"
            },
            {
              brand: "Subaru",
              src: require("../assets/images/banners/Subaru/CM-SL-CA-Subaru-Playful.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/272/original/CM-SL-CA-Subaru-Playful.jpg?1671483752"
            },
            {
              brand: "Toyota",
              src: require("../assets/images/banners/Toyota/CM-MS-CA-23-Toyota-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/276/original/CM-MS-CA-23-Toyota-Playful.jpeg?1671483766"
            },
            {
              brand: "Volkswagen",
              src: require("../assets/images/banners/Volkswagen/CM-SL-CA-Volkswagen-Playful.jpg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/280/original/CM-SL-CA-Volkswagen-Playful.jpg?1671483775"
            },
            {
              brand: "Volvo",
              src: require("../assets/images/banners/Volvo/CM-SL-CA-Volvo-Playful.jpeg"),
              websrc: "https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/325/284/original/CM-SL-CA-Volvo-Playful.jpeg?1671483784"
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.sortPictures();
    window.scrollTo(0, 0);
  },
  methods: {
    sortPictures() {
      const brand = this.$store.state.brand;
      const brandExists = this.banners[0].pictures.findIndex(
        (el) => el.brand === brand
      );
      if (brandExists === -1) return;
      this.banners.forEach((category, i) => {
        const brandPicture = category.pictures.find(
          (picture) => picture.brand === brand
        );
        let filtered = category.pictures.filter((picture) => {
          return picture.brand !== brand;
        });
        filtered.unshift(brandPicture);
        this.banners[i].pictures = filtered;
      });
    },
  },
  computed: {
    chunkBanners() {
      return _.chunk(this.banners, 2);
    },
  },
  components: {
    Banner,
  },
};
</script>
